import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleJpkVatGroupCollectionQuery, SaleJpkVatGroupCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleJpkVatGroupCollectionQuery)
@Wrapper(SaleJpkVatGroupCollectionQueryHandlerBase)
export class SaleJpkVatGroupCollectionQueryHandlerHandler {
    public constructor(
        http: Http
    ) { }
}
